import { render, staticRenderFns } from "./AutresVideos.vue?vue&type=template&id=a5999ba8"
import script from "./AutresVideos.vue?vue&type=script&lang=ts"
export * from "./AutresVideos.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports